import React from 'react'
import styled from 'styled-components'
import {StyledTable, StyledTd, StyledTh} from '../../../../../../styledComponents/StyledTypeDefinitions'
import {Nullable} from '../../../../../../app/TypeHelpers'

interface Props {
    sealFields: SealField[]
}

export interface SealField {
    applyStatus: string
    seal: Nullable<string> | undefined
    sortOrder: number
}

export const NatSealField: React.FC<Props> = props => {
    const {sealFields} = props

    const sortedSeals = sealFields.sort((prev, next) => next.sortOrder - prev.sortOrder)

    return (
        <SealFieldTable>
            <tbody>
            <tr>
                {sortedSeals.map((sealField, index) => (
                    <SealFieldTh key={index}>{sealField.applyStatus}</SealFieldTh>
                ))}
            </tr>
            <tr>
                {sortedSeals.map((sealField, index) => (
                    <SealFieldTd key={index}>{sealField.seal}</SealFieldTd>
                ))}
            </tr>
            </tbody>
        </SealFieldTable>
    )

    NatSealField.displayName = 'NatSealField'
}

const SealFieldTable: StyledTable = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 9pt;
`

const SealFieldTh: StyledTh = styled.th`
  border: solid 0.5pt black;
  font-weight: 400;
`

const SealFieldTd: StyledTd = styled.td`
  border: solid 0.5pt black;
  width: 28mm;
  height: 20mm;
  text-align: center;
`